export default class RegisterUserModel{
    constructor(
        userId,
        userName,
        dob,
        nationality,
        recieptNumber,
        serialNumber,
        dateofReceipt,
        passportNumber,
        passportIssueDate,
        cdvNumber,
        cdcIssueDate,
        cdcIssuePlace,
        address,
        country,
        whatsAppNumber,
        mobileNumber,
        email,
        contactNumber,
        contactAddress,
        traininInstituteName,
        trainingCourse,
        traininInstituteAddress,
        joiningDate,
        courseCompletionDate,
        tarbookNumber,
        forCollection,
        forPayment,
    ){
        this.userId = userId === undefined ? 0 : userId;
        this.userName = userName === undefined ? "" : userName;
        this.dob = dob === undefined ? "" : dob;
        this.nationality = nationality === undefined ? "" : nationality;
        this.recieptNumber = recieptNumber === undefined ? "" : recieptNumber;
        this.serialNumber = serialNumber === undefined ? "" : serialNumber;
        this.dateofReceipt = dateofReceipt === undefined ? "" : dateofReceipt;
        this.passportNumber = passportNumber === undefined ? "" : passportNumber;
        this.passportIssueDate = passportIssueDate === undefined ? "" : passportIssueDate;
        this.cdvNumber = cdvNumber === undefined ? "" : cdvNumber;
        this.cdcIssueDate = cdcIssueDate === undefined ? "" : cdcIssueDate;
        this.cdcIssuePlace = cdcIssuePlace === undefined ? "" : cdcIssuePlace;
        this.address = address === undefined ? "" : address;
        this.country = country === undefined ? "" : country;
        this.whatsAppNumber = whatsAppNumber === undefined ? "" : whatsAppNumber;
        this.mobileNumber = mobileNumber === undefined ? "" : mobileNumber;
        this.email = email === undefined ? "" : email;
        this.contactNumber = contactNumber === undefined ? "" : contactNumber;
        this.contactAddress = contactAddress === undefined ? "" : contactAddress;
        this.traininInstituteName = traininInstituteName === undefined ? "" : traininInstituteName;
        this.trainingCourse = trainingCourse === undefined ? "" : trainingCourse;
        this.traininInstituteAddress = traininInstituteAddress === undefined ? "" : traininInstituteAddress;
        this.joiningDate = joiningDate === undefined ? "" : joiningDate;
        this.courseCompletionDate = courseCompletionDate === undefined ? "" : courseCompletionDate;
        this.tarbookNumber = tarbookNumber === undefined ? "" : tarbookNumber;
        this.forCollection = forCollection === undefined ? "" : forCollection;
        this.forPayment = forPayment === undefined ? "" : forPayment;
    }
}